<!--
 * @Author: wuhao
 * @Date: 2020-04-17 17:23:50
 * @LastEditors: wuhao
 * @LastEditTime: 2020-05-18 20:51:09
 * @Description: 二次封装el-form
 -->
<template>
  <el-form
    ref="form"
    class="apex-form"
    :class="className"
    :model="data"
    :rules="rulesObj"
    :label-width="labelWidth"
    :size="getSize()"
  >
    <template v-for="(item, index) in getConfigList()">
      <h4 v-if="item.type === 'title'" :key="item.title" class="title">
        {{ item.title }}
      </h4>
      <el-form-item
        v-else
        :key="index"
        :ref="item.value"
        :prop="item.value"
        :label="item.label"
        :label-width="item.labelWidth"
        :class="item.className"
      >
        <!-- solt -->
        <template v-if="item.type === 'slot'">
          <slot :name="'form-' + item.value" />
        </template>
        <!-- 普通输入框 -->
        <el-input
          v-if="item.type === 'input' || item.type === 'password'"
          v-model="data[item.value]"
          :type="item.type"
          :disabled="item.disabled"
          :clearable="item.clearable === false ? item.clearable : true"
          :placeholder="getPlaceholder(item)"
          @focus="handleEvent(item.emit, data[item.value])"
        />
        <!-- 文本输入框 -->
        <el-input
          v-if="item.type === 'textarea'"
          v-model.trim="data[item.value]"
          :type="item.type"
          :disabled="item.disabled"
          :placeholder="getPlaceholder(item)"
          :autosize="item.autosize || { minRows: 2, maxRows: 10 }"
          @focus="handleEvent(item.emit, data[item.value])"
        />
        <!-- 计数器 -->
        <el-input-number
          v-if="item.type === 'inputNumber'"
          v-model="data[item.value]"
          size="small"
          :min="item.min"
          :max="item.max"
          @change="handleEvent(item.emit, data[item.value])"
        />
        <!-- 选择框 -->
        <el-select
          v-if="item.type === 'select'"
          v-model="data[item.value]"
          :disabled="item.disabled"
          :clearable="item.clearable"
          :filterable="item.filterable"
          :placeholder="getPlaceholder(item)"
          @change="handleEvent(item.emit, data[item.value])"
        >
          <el-option
            v-for="(childItem, childIndex) in listTypeInfo[item.list]"
            :key="childIndex"
            :label="childItem.key"
            :value="childItem.value"
          />
        </el-select>
        <!-- 日期选择框 -->
        <el-date-picker
          v-if="item.type === 'date'"
          v-model="data[item.value]"
          :type="item.dateType"
          :picker-options="item.TimePickerOptions"
          :clearable="item.clearable"
          :disabled="item.disabled"
          :placeholder="getPlaceholder(item)"
          :value-format="item.valueFormat || 'yyyy-MM-dd HH:mm:ss'"
          @focus="handleEvent(item.emit, data[item.value])"
        />
        <!-- 信息展示框 -->
        <el-tag v-if="item.type === 'tag'">
          {{
            $fn.getDataName({
              dataList: listTypeInfo[item.list],
              value: "value",
              label: "key",
              data: data[item.value]
            }) || "-"
          }}
        </el-tag>
      </el-form-item>
    </template>
    <el-form-item v-if="showBtn" class="el-form-block">
      <el-button type="primary" @click="submitForm">{{
        submitBtnText
      }}</el-button>
      <el-button @click="resetForm">{{ cancleBtnText }}</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: 'ApexForm',
  props: {
    // 表单大小
    size: {
      type: String,
      default: ''
    },
    // 自定义类名
    className: {
      type: String,
      default: ''
    },
    // 表单数据
    data: {
      type: Object,
      default: () => { }
    },
    // 相关字段
    fieldList: {
      type: Array,
      default: () => []
    },
    // 验证规则
    rules: {
      type: Object,
      default: () => { }
    },
    // 相关的列表
    listTypeInfo: {
      type: Object,
      default: () => { }
    },
    // label宽度
    labelWidth: {
      type: String,
      default: '120px'
    },
    refObj: {
      type: Object,
      default: () => { }
    },
    // 是否显示底部操作按钮
    showBtn: {
      type: Boolean,
      default: true
    },
    // 提交按钮文字
    submitBtnText: {
      type: String,
      default: function() {
        return this.isEn ? 'submit' : '提交'
      }
    },
    // 重置按钮文字
    cancleBtnText: {
      type: String,
      default: function() {
        return this.isEn ? 'reset' : '重置'
      }
    },
    // 语言
    lang: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
    }
  },
  computed: {
    rulesObj() {
      return Object.assign({}, this.initValidator(this.fieldList), this.rules)
    },
    isEn() {
      const lang = this.lang || this.$APEXUI.lang
      return lang === 'en'
    }
  },
  watch: {
    data: {
      handler: function(val) {
        // 将form实例返回到父级
        this.$emit('update:refObj', this.$refs.form)
      },
      deep: true // 深度监听
    }
  },
  mounted() {
    // 将form实例返回到父级
    this.$emit('update:refObj', this.$refs.form)
  },
  methods: {
    // 获取size属性
    getSize() {
      return this.size || (this.$ELEMENT || {}).size
    },
    // 获取字段列表
    getConfigList() {
      // eslint-disable-next-line no-prototype-builtins
      return this.fieldList.filter(item => !item.hasOwnProperty('show') || (item.hasOwnProperty('show') && item.show))
    },
    // 得到placeholder的显示
    getPlaceholder(row) {
      if (row.placeholder || row.placeholder === '') return row.placeholder
      let placeholder
      if (row.type === 'input' || row.type === 'textarea') {
        placeholder = (this.isEn ? 'Please Enter ' : '请输入') + row.label
      } else if (row.type === 'select' || row.type === 'date') {
        placeholder = (this.isEn ? 'Please Select ' : '请选择') + row.label
      } else {
        placeholder = row.label
      }
      return placeholder
    },
    // 派发的相关事件
    handleEvent(emit, value) {
      this.$emit(`${emit}`, value)
    },
    // 初始化校验规则
    initValidator(fieldList) {
      const obj = {}
      // 循环字段列表
      for (const item of fieldList) {
        const type = (item.type === 'select' || item.type === 'date') ? (this.isEn ? 'select ' : '选择') : (this.isEn ? 'enter ' : '输入')
        if (item.required) {
          if (item.validator) {
            obj[item.value] = {
              required: item.required,
              validator: item.validator,
              trigger: item.trigger || ((item.type === 'select' || item.type === 'date') ? 'change' : 'blur')
            }
          } else {
            obj[item.value] = {
              required: item.required,
              message: (this.isEn ? 'Please ' : '请') + type + item.label,
              trigger: item.trigger || ((item.type === 'select' || item.type === 'date') ? 'change' : 'blur')
            }
          }
        } else if (item.validator) {
          obj[item.value] = {
            validator: item.validator,
            trigger: item.trigger || ((item.type === 'select' || item.type === 'date') ? 'change' : 'blur')
          }
        }
      }
      return obj
    },
    submitForm() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate((valid, object) => {
          if (valid) {
            this.$emit('submit')
            resolve(true)
          } else {
            this.scrollView(object)
            return false
          }
        })
      })
    },
    resetForm() {
      this.$refs.form.resetFields()
      this.$emit('cancle')
    },
    // 滚动到固定地方
    scrollView(object) {
      for (const i in object) {
        let dom = this.$refs[i]
        // 这里是针对遍历的情况（多个输入框），取值为数组
        if (Object.prototype.toString.call(dom) !== '[object Object]') {
          dom = dom[0]
        }
        // 第一种方法（包含动画效果）
        dom.$el.scrollIntoView({ // 滚动到指定节点
          // 值有 start、center、end、nearest，当前显示在视图区域中间
          block: 'start',
          // 值有 auto、instant、smooth，缓动动画（当前是慢速的）
          behavior: 'smooth'
        })
        break // 因为我们只需要检测一项,所以就可以跳出循环了
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// 自定义form相关
.apex-form {
  .title {
    border-top: 2px solid #e7eaec;
    font-weight: 600 !important;
    padding-top: 10px;
    color: #676a6c !important;
  }
  .el-form-item {
    display: inline-block;
    width: 48%;
    .el-form-item__content {
      .el-input,
      .el-select,
      .el-textarea {
        // width: 100%;
        width: calc(100% - 20px);
      }
      .el-input-number {
        .el-input {
          width: inherit;
        }
      }
    }
  }
  .el-form-block {
    display: block;
    width: 100%;
    .el-form-item__content {
      .el-textarea {
        width: 100%;
      }
    }
  }
}
.page-form-block {
  .el-form-item {
    display: block;
    .el-form-item__content {
      .el-input,
      .el-select,
      .el-textarea {
        width: inherit;
      }
      .el-input-number {
        .el-input {
          width: inherit;
        }
      }
    }
  }
  .el-form-block {
    display: block;
    width: 100%;
    .el-form-item__content {
      .el-textarea {
        width: 100%;
      }
    }
  }
}
</style>
